'use client'

import * as React from 'react'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'

import { GridSection } from '@/components/marketing/fragments/grid-section'
import { NumberTicker } from '@/components/marketing/fragments/number-ticket'
import { cn } from '@/lib/utils'

const DATA = [
  { value: 20, suffix: '+', description: msg`Multi-industry ecosystem` },
  { value: 80, suffix: '+', description: msg`Employees` },
  { value: 40, suffix: '+', description: msg`Awards & certifications` },
  { value: 100, suffix: '+', description: msg`Major partners & clients` }
]

export function Stats(): React.JSX.Element {
  const { i18n } = useLingui()
  return (
    <GridSection>
      <div className='grid grid-cols-2 divide-x divide-border lg:grid-cols-4 overflow-hidden'>
        {DATA.map((stat, index) => (
          <div
            key={index}
            className={cn(
              'justify-top flex flex-col items-center border-dashed p-6 text-center lg:p-8 ',
              (index === 2 || index === 3) && 'border-t lg:border-t-0'
            )}
          >
            <p className='whitespace-nowrap text-2xl font-semibold md:text-3xl'>
              <NumberTicker value={stat.value} />
              {stat.suffix}
            </p>
            <p className='mt-2 whitespace-nowrap text-xs text-muted-foreground sm:text-sm'>
              {i18n._(stat.description)}
            </p>
          </div>
        ))}
      </div>
    </GridSection>
  )
}
